const mediaItems = [
  {
    img: 'https://readdy.ai/api/search-image?query=Dramatic%20video%20thumbnail%20style%20image%20with%20dark%20background%20and%20red%20accent%20lighting%2C%20mysterious%20atmosphere%2C%20play%20button%20area%20empty%2C%20cinematic%20photography%2C%20entertainment%20news%20aesthetic%2C%20no%20people%20or%20text&width=600&height=340&seq=media-01-2026&orientation=landscape',
    title: '网红爆料：千万粉丝博主私密聊天记录完整还原',
    duration: '15:28',
    views: '128.6万',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Dramatic%20video%20thumbnail%20with%20warm%20amber%20lighting%20and%20dark%20shadows%2C%20mysterious%20scene%2C%20professional%20photography%20style%2C%20entertainment%20theme%2C%20play%20button%20area%20empty%2C%20no%20people%20or%20text&width=600&height=340&seq=media-02-2026&orientation=landscape',
    title: '明星八卦：当红小生深夜私会神秘女子全程追踪',
    duration: '22:15',
    views: '96.3万',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Dramatic%20video%20thumbnail%20with%20crimson%20and%20shadow%20contrast%2C%20mysterious%20atmosphere%2C%20documentary%20style%2C%20dark%20background%2C%20play%20button%20area%20empty%2C%20no%20people%20or%20text&width=600&height=340&seq=media-03-2026&orientation=landscape',
    title: '深度扒皮：MCN机构内部运营黑幕全方位解密',
    duration: '31:42',
    views: '87.5万',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Dramatic%20video%20thumbnail%20with%20golden%20spotlight%20and%20dark%20backdrop%2C%20premium%20production%20style%2C%20mysterious%20scene%2C%20play%20button%20area%20empty%2C%20no%20people%20or%20text&width=600&height=340&seq=media-04-2026&orientation=landscape',
    title: '综艺揭秘：选秀节目暗箱操作证据链完整曝光',
    duration: '18:56',
    views: '73.2万',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Dramatic%20video%20thumbnail%20with%20rich%20red%20and%20black%20contrast%2C%20investigative%20journalism%20style%2C%20dark%20atmosphere%2C%20play%20button%20area%20empty%2C%20no%20people%20or%20text&width=600&height=340&seq=media-05-2026&orientation=landscape',
    title: '独家首发：某大V数据造假第三方审计报告解密',
    duration: '25:10',
    views: '65.8万',
  },
];

export default function Media() {
  return (
    <section id="media" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
            精选视频
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            最受欢迎的黑料视频精选，高清正片在线播放
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 md:gap-5">
          {mediaItems.map((item, i) => (
            <div
              key={i}
              className="group bg-white rounded-2xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden bg-background-100">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/35 transition-colors flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-white/90 flex items-center justify-center group-hover:scale-110 transition-transform">
                    <i className="ri-play-fill text-xl text-primary-600 ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-0.5 text-xs bg-black/70 text-white rounded-md whitespace-nowrap">
                  {item.duration}
                </div>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="text-xs md:text-sm font-medium text-foreground-900 leading-snug line-clamp-2 mb-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <div className="flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-eye-line"></i>
                  <span>{item.views}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}